import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import { useTheme } from "../../context/ThemeContext";
function NtOnboardingStepper({ steps = [], currentStep }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={styles.container}>
      {steps.map((step, index) => {
        const isActive = index === currentStep;
        const isDone = index < currentStep;
        const isLast = index === steps.length - 1;
        return (
          <View key={step.key} style={styles.stepWrap}>
            <View style={styles.step}>
              <View
                style={[
                  styles.num,
                  isDone && styles.numDone,
                  isActive && styles.numActive,
                ]}
              >
                {isDone ? (
                  <NtMaterialIcon name="check" size={12} color="#0b1a13" />
                ) : (
                  <NtText
                    style={[
                      styles.numText,
                      isActive && styles.numTextActive,
                    ]}
                  >
                    {index + 1}
                  </NtText>
                )}
              </View>
              <NtText
                style={[
                  styles.label,
                  (isActive || isDone) && styles.labelActive,
                ]}
              >
                {step.title}
              </NtText>
            </View>
            {!isLast ? (
              <View
                style={[styles.line, isDone && styles.lineDone]}
              />
            ) : null}
          </View>
        );
      })}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      flexDirection: "row",
      alignItems: "center",
      paddingVertical: 16,
      paddingHorizontal: 36,
      backgroundColor: t.surface,
      borderBottomWidth: 1,
      borderBottomColor: t.borderSoft,
    },
    stepWrap: {
      flexDirection: "row",
      alignItems: "center",
      flex: 1,
    },
    step: { flexDirection: "row", alignItems: "center", gap: 9 },
    num: {
      width: 24,
      height: 24,
      borderRadius: 12,
      backgroundColor: t.surface3,
      borderWidth: 1,
      borderColor: t.border,
      alignItems: "center",
      justifyContent: "center",
    },
    numActive: { backgroundColor: t.brand2, borderColor: t.brand2 },
    numDone: { backgroundColor: t.green, borderColor: t.green },
    numText: {
      fontSize: 11,
      fontWeight: "700",
      color: t.textDim,
    },
    numTextActive: { color: "#ffffff" },
    label: { fontSize: 12, color: t.textDim },
    labelActive: { color: t.text, fontWeight: "600" },
    line: {
      flex: 1,
      height: 1,
      backgroundColor: t.border,
      marginHorizontal: 12,
    },
    lineDone: { backgroundColor: t.green },
  });

export default NtOnboardingStepper;
